module.exports = __webpack_public_path__ + "fonts/Open_Sans-600-cyrillic-ext19.f784b6e.woff2";